module.exports = __webpack_public_path__ + "static/img/003.1045747.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/003.png
// module id = gLxw
// module chunks = 1